exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerLeft {\n  width: 50%; }\n\n.containerRight {\n  width: 50%; }\n\n.padding-corporate {\n  margin-bottom: -0.75rem; }\n\n.par-change {\n  margin-left: -0.375rem; }\n\n.dividend-payment {\n  margin-right: -0.375rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/corporate-screen/corporate-screen.component.scss
// module id = ../../../../../src/app/securities-level/corporate-action/corporate-screen/corporate-screen.component.scss
// module chunks = main